function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none"
}, React.createElement("path", {
  fill: "#2170F4",
  d: "M12.667 14.667h.666v-1.334h-.666v-.666c-.003-1.648-.872-3.173-2.289-4.014-.237-.14-.378-.364-.378-.6v-.106c0-.236.141-.46.377-.6 1.417-.841 2.287-2.366 2.29-4.014v-.666h.666V1.333H2.667v1.334h.666v.666c.003 1.648.873 3.173 2.29 4.014.236.14.377.364.377.6v.106c0 .236-.141.46-.377.6-1.417.841-2.287 2.366-2.29 4.014v.666h-.666v1.334h10zm-1.334-12v.666c0 .722-.236 1.424-.669 2H5.336c-.433-.576-.668-1.278-.67-2v-.666h6.667zM6.3 9.8c.647-.382 1.033-1.036 1.033-1.748V8h1.334v.053c0 .712.386 1.366 1.034 1.748.599.357 1.07.893 1.348 1.532H4.95c.278-.64.75-1.175 1.349-1.532z"
}), React.createElement("path", {
  d: "M0 0H16V16H0z"
}));

var SvgRecoverEmailWaiting = function SvgRecoverEmailWaiting(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRecoverEmailWaiting, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/recover_email_waiting.81d54314.svg";
export { ForwardRef as ReactComponent };